






















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class ItDisplay extends Vue {
  @Prop({type: String, default: ''}) title!: string
  @Prop({type: String, default: ''}) subtitle!: string
  @Prop({type: [String, Number], default: ''}) value!: string
  @Prop({type: String, default: null}) icon!: string | null
  @Prop({type: String, default: ''}) innerClass!: string
  @Prop({type: Boolean}) inverted?: boolean
}
